<template>
  <!--
    Selector de layout — plan 27_09_2026 §4.1.

    Antes este archivo montaba HeaderPage, FooterPage y WhatsAppButton
    incondicionalmente, así que el panel de gestión mostraba la cabecera
    comercial ("Cotiza ahora") y el footer institucional. Ahora cada ruta
    declara su layout en `meta.layout` y aquí sólo se elige cuál envuelve
    a la vista. El contenido público no cambió: se movió tal cual a
    PublicLayout.vue.
  -->
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import { computed, ref, onBeforeMount, provide } from 'vue';
import { useRoute } from 'vue-router';
import PublicLayout from './layouts/PublicLayout.vue';
import AdminLayout from './layouts/AdminLayout.vue';
import AuthLayout from './layouts/AuthLayout.vue';
import { fetchCompanyInfo } from '@/services/dbConsults.js';

export default {
  name: 'App',
  components: { PublicLayout, AdminLayout, AuthLayout },
  setup() {
    const route = useRoute();
    const company = ref(null);
    const error = ref(null);
    const companyId = 1; // ID fijo para la empresa unica para pagina web

    /**
     * `VUE_APP_FEATURE_ADMIN_UI` es el interruptor de emergencia del plan
     * (§8.4, precedente: VUE_APP_FEATURE_CUSTOMIZER). Con la variable en
     * 'false' todas las rutas vuelven al layout público sin revertir código.
     */
    const adminUiEnabled = process.env.VUE_APP_FEATURE_ADMIN_UI !== 'false';

    const LAYOUTS = { admin: AdminLayout, auth: AuthLayout };

    const layout = computed(() => {
      const wanted = route.meta?.layout;
      // El interruptor de emergencia sólo afecta al panel; las pantallas de
      // acceso no dependen de él.
      if (wanted === 'admin' && !adminUiEnabled) return PublicLayout;
      return LAYOUTS[wanted] || PublicLayout;
    });

    onBeforeMount(loadCompany);

    async function loadCompany() {
      const { company: data, error: err } = await fetchCompanyInfo(companyId);
      company.value = data;
      error.value = err;
    }

    // La información de empresa la consumen tanto el footer público como las
    // vistas administrativas, así que sigue provista desde la raíz.
    provide('company', company);
    provide('reloadCompany', loadCompany);

    return { layout, company, error };
  },
};
</script>
